import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { WhatsNewPane } from 'owa-header-pane';
import { getActiveCharm } from 'owa-header-store';
import strings from 'owa-strings/owa-whatsnew-strings';
import { getUnreadWhatsNewCardNumber, getWhatsNewCardNumber, shouldAutoExpandPane, initializeWhatsNewLazy, } from 'owa-whats-new';
import * as React from 'react';
import HeaderCharm from './HeaderCharm';
import { logUsage } from 'owa-analytics';
import { toggleCharm } from 'owa-header-store';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { getAllGetStartedTasksNumber } from 'owa-get-started';
var WhatsNewCharm = /** @class */ (function (_super) {
    tslib_1.__extends(WhatsNewCharm, _super);
    function WhatsNewCharm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onWhatsNewClicked = function () {
            if (getActiveCharm() !== 8 /* WhatsNewCharm */) {
                logUsage('whatsNewCharmClicked');
            }
            if (!isControlFeatureEnabled('fwk-o365shellheader')) {
                toggleCharm(8 /* WhatsNewCharm */);
            }
        };
        return _this;
    }
    WhatsNewCharm.prototype.componentDidMount = function () {
        initializeWhatsNewLazy.importAndExecute().then(function () {
            if (shouldAutoExpandPane()) {
                toggleCharm(8 /* WhatsNewCharm */);
            }
        });
    };
    WhatsNewCharm.prototype.render = function () {
        var whatsNewItems = getWhatsNewCardNumber();
        if (whatsNewItems > 0 &&
            (!isControlFeatureEnabled('auth-getStarted') || getAllGetStartedTasksNumber() === 0)) {
            return (React.createElement("div", null,
                React.createElement(HeaderCharm, { key: "whatsnew", icons: {
                        iconName: "Megaphone" /* Megaphone */,
                    }, title: strings.whatsNew_FlexPane_Title, ariaLabel: strings.whatsNew_FlexPane_Title, behavior: {
                        paneComponent: isControlFeatureEnabled('fwk-o365shellheader')
                            ? null
                            : WhatsNewPane,
                        charm: 8 /* WhatsNewCharm */,
                        onClick: this.onWhatsNewClicked,
                    }, getBadgeCount: getUnreadWhatsNewCardNumber })));
        }
        return null;
    };
    WhatsNewCharm = tslib_1.__decorate([
        observer
    ], WhatsNewCharm);
    return WhatsNewCharm;
}(React.Component));
export default WhatsNewCharm;
//# sourceMappingURL=WhatsNewCharm.js.map